var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"ui-check"},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.value},on:{"change":function($event){return _vm.$emit('input', $event.target.checked)}}}),_c('span',[_vm._t("default"),(_vm.hint)?_c('small',[_vm._v(_vm._s(_vm.hint))]):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }